// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth /*, connectAuthEmulator */ } from "firebase/auth";
import { getFirestore /*, connectFirestoreEmulator*/ } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
import { getFunctions /*, connectFunctionsEmulator*/ } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBaxoOFd_2MS-hFq2b3kCtBDWBvC0ntt-g",
  authDomain: "provengroupdispatch.firebaseapp.com",
  projectId: "provengroupdispatch",
  storageBucket: "provengroupdispatch.appspot.com",
  messagingSenderId: "1018136289773",
  appId: "1:1018136289773:web:e4185c5ce17dab204ac7e4",
  measurementId: "G-EPDBB9QERW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const auth = getAuth(app);
// connectAuthEmulator(auth, "http://127.0.0.1:9099");

const db = getFirestore(app);
// connectFirestoreEmulator(db, '127.0.0.1', 8080);

const functions = getFunctions(app);
// connectFunctionsEmulator(functions, "127.0.0.1", 5001);

//export const storage = getStorage(app);

export { auth, db, functions };